module.exports = __webpack_public_path__ + "static/media/Icon-Mid-West.c63e1ffc.png";